import { useAoApi } from "@lending/lib/api";
import { STANDARD_QUERY_CACHE_CONFIG } from "@lending/lib/queryConfig";

function useGetConsumerApplicationQuery(accountApplicationUuid?: string) {
  const $aoApi = useAoApi();

  return $aoApi.useQuery(
    "get",
    "/v2/account_opening/consumer/applications/{uuid}/",
    {
      params: {
        path: {
          uuid: accountApplicationUuid ?? "",
        },
      },
    },
    {
      ...STANDARD_QUERY_CACHE_CONFIG,
      enabled: Boolean(accountApplicationUuid),
      retry: false,
      refetchOnMount: true,
    }
  );
}

export { useGetConsumerApplicationQuery };
